<template>
    <div 
        class="kv-tooltip-container" 
        ref="container"
        @mouseenter="showTooltip"
        @mouseleave="hideTooltip"
    >
        <slot></slot>
        
        <transition name="fade">
            <div 
                v-if="isVisible" 
                class="kv-tooltip" 
                ref="tooltip"
                :style="positionStyle"
            >
                <slot name="content">
                    {{ tooltipText }}
                </slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "KvTooltip",
    props: {
        text: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        },
        placement: {
            type: String,
            default: "top", // top, bottom, left, right
        },
        delay: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        tooltipText() {
            return this.title || this.text;
        }
    },
    data() {
        return {
            isVisible: false,
            positionStyle: {
                top: "0px",
                left: "0px",
            },
            timeoutId: null
        };
    },
    methods: {
        showTooltip() {
            if (this.disabled || !this.tooltipText) return;

            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
            
            this.timeoutId = setTimeout(() => {
                this.isVisible = true;
                this.$nextTick(() => {
                    this.adjustPlacement();
                });
            }, this.delay);
        },
        hideTooltip() {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.isVisible = false;
        },
        adjustPlacement() {
            const container = this.$refs.container;
            const tooltip = this.$refs.tooltip;

            if (!container || !tooltip) return;

            const containerRect = container.getBoundingClientRect();
            const tooltipRect = tooltip.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            let top = 0;
            let left = 0;

            switch (this.placement) {
                case "top":
                    top = containerRect.top - tooltipRect.height - 8;
                    left = containerRect.left + (containerRect.width / 2) - (tooltipRect.width / 2);
                    break;
                case "bottom":
                    top = containerRect.bottom + 8;
                    left = containerRect.left + (containerRect.width / 2) - (tooltipRect.width / 2);
                    break;
                case "left":
                    top = containerRect.top + (containerRect.height / 2) - (tooltipRect.height / 2);
                    left = containerRect.left - tooltipRect.width - 8;
                    break;
                case "right":
                    top = containerRect.top + (containerRect.height / 2) - (tooltipRect.height / 2);
                    left = containerRect.right + 8;
                    break;
            }

            // Impede de sair da tela
            top = Math.max(4, Math.min(top, viewportHeight - tooltipRect.height - 4));
            left = Math.max(4, Math.min(left, viewportWidth - tooltipRect.width - 4));

            this.positionStyle = {
                top: `${top}px`,
                left: `${left}px`,
            };
        }
    },
    beforeDestroy() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }
};
</script>

<style lang="less">
.kv-tooltip-container {
    position: relative;
    display: inline-block;
}

.kv-tooltip {
    position: fixed;
    background: #1F2937;
    color: #FFFFFF;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.4;
    z-index: 1000;
    pointer-events: none;
    white-space: nowrap;
    max-width: 300px;
    word-wrap: break-word;
    white-space: normal;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* === Animação === */
.fade-enter-active {
    transition: opacity 0.15s ease, transform 0.15s ease;
}

.fade-leave-active {
    transition: opacity 0.1s ease, transform 0.1s ease;
}

.fade-enter-from {
    opacity: 0;
    transform: translateY(4px);
}

.fade-leave-to {
    opacity: 0;
    transform: translateY(4px);
}
</style>

